import dbflex from "@/util/dbflex";
import Vue from "vue";
// import _ from "lodash";

var plugin = new Vue();
export default {
    namespaced: true,
    state: {
        jenis :{
            data: [
                { text: "RPT", value: 1 },
                { text: "Non-RPT", value: 0 },
            ],
            object :{
                1:"RPT",
                0:"Non-RPT"
            }
        },
        role:{
            data:[
                {text:"Admin",value:"ADMIN"},
                {text:"User",value:"USER"},
            ],
        },
        statusPengawasan : {
            object :{
                0: "Draft",
                1: "Ajukan",
                2: "Sudah Diajukan",
                3: "Review Dalnis",
                4: "Review WPJ",
                5: "Revisi"
            }
        },
        status : [
            {
                text : "Ajukan",
                color : "blue--text",
                editable : true,
            },{
                text : "Diajukan",
                color : "teal white--text",
                editable : false,
            },{
                text : "Sudah Diajukan",
                color : "teal white--text",
                editable : false,
            },{
                text : "Review Ketua",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Review Dalnis",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Review WPJ",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Review Inspektur",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Ajukan Revisi",
                color : "deep-orange--text",
                editable : true,
            }
        ],
        statuskerja : [
            {
                text : "Ajukan",
                color : "blue--text",
                editable : true,
            },{
                text : "Review Ketua",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Review Dalnis",
                color : "yellow darken-2 white--text",
                editable : false,
            },{
                text : "Selesai",
                color : "teal white--text",
                editable : false,
            }
        ],
        jabatan :{
            data: [
                { text: "Anggota", value: "ANGGOTA" },
                { text: "Ketua Tim", value: "KT" },
                { text: "Pengendali Teknis", value: "DALNIS" },
                { text: "Wakil Penanggung Jawab", value: "WPJ" },
                { text: "Penanggung Jawab / Kepala Dinas", value: "PJ" },
            ],
            kodetotext :{
                "ANGGOTA": "Anggota",
                "KT": "Ketua Tim",
                "DALNIS": "Pengendali Teknis",
                "WPJ": "Wakil Penanggung Jawab",
                "PJ": "Penanggung Jawab / Kepala Dinas",
            }
        },
        anggota :{
            data: [],
            object:{},
            loading : false,
        },
        jabatanbyrpt:"",
        statusTindakLanjut : {
            object :{
                0: "Draft",
                1: "Sudah Diajukan"
            }
        },
        statusConfigTindakLanjut : [
            {
                text : "Draft",
                color : "blue--text",
                editable : true,
            },{
                text : "Sudah Diajukan",
                color : "teal white--text",
                editable : false,
            }
        ]
    },
    mutations: {
        resetDataAnggota(state) {
            state.anggota.data = [];
        },
        setDataAnggota(state, anggota) {
            state.anggota.data = anggota;
        },
        isAnggotaLoading(state, loading) {
            state.anggota.loading = loading;
        },
        setJabatanByRpt(state, jabatanbyrpt) {
            state.jabatanbyrpt = jabatanbyrpt;
        },
    },
    actions: {
        refreshAnggota(context) {
            let p = {},
                filter = new dbflex();

            // constructing filter
            p.Orders = ["Nama"];
            filter.nin("Username", ["root","admin"]);

            // generate filter
            p.Filter = filter.get();

            context.commit("isAnggotaLoading", true);
            context.commit("resetDataAnggota");
            plugin.$axios
                .post("/user/list", p)
                .then((res) => {
                    const result = res.data;

                    let mapped =[]
                    result.Data.forEach((val)=>{
                        mapped.push({
                            text : val.Name,
                            value : val.ID
                        })
                        
                       })
                    context.commit("setDataAnggota", mapped);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isAnggotaLoading", false);
                });
        },
        refreshAnggotaPkp(context,pkpid){

            context.commit("isAnggotaLoading", true);
            context.commit("resetDataAnggota");
            plugin.$axios
                .get("/pkp/getmember/"+pkpid)
                .then((res) => {
                    const result = res.data;

                    let mapped =[]
                    result.Data.forEach((val)=>{
                        mapped.push({
                            text : val.User.Name,
                            value : val.UserID
                        })
                        
                       })
                    context.commit("setDataAnggota", mapped);
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    context.commit("isAnggotaLoading", false);
                });
        },
        refreshJabatan(context,rptid){
            let jabatan = ""
            console.log(rptid);
            plugin.$axios
              .get(`/rpt/getjabatanbyrpt/${rptid}`)
              .then((res) => {
                jabatan = res.data.Data.Jabatan;
              })
              .finally(()=>{
                context.commit("setJabatanByRpt", jabatan);
              })
          }
    },
    getters: {
        isAnggotaLoading(state) {
            return state.anggota.loading;
        },
        getJabatanByRpt(state) {
            return state.jabatanbyrpt;
        },
    },
};
